import React from "react";
import {
  FaInstagram,
  FaTwitter,
  FaGithub,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";
import "./Sidebar.css";

export const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="socialContainer d-flex flex-column justify-content-center align-items-center">
        <a href="https://www.linkedin.com/in/piyush-kesarwani-809a30219/" target="_blank" rel="noreferrer">
          <FaLinkedin className="fs-5 mt-5 text-light socialIcons" />
        </a>
        <a href="https://www.instagram.com/piyush_kesarwani22/" target="_blank" rel="noreferrer">
          <FaInstagram className="fs-5 mt-5 text-light socialIcons" />
        </a>
        <a href="https://twitter.com/Hy_piyush" target="_blank" rel="noreferrer">
          <FaTwitter className="fs-5 mt-5 text-light socialIcons" />
        </a>
        <a href="https://github.com/piyushkesarwani" target="_blank" rel="noreferrer">
          <FaGithub className="fs-5 mt-5 text-light socialIcons" />
        </a>
        <a href="mailto:piyushkesarwan2207@gmail.com" target="_blank" rel="noreferrer">
          <AiOutlineMail className="fs-5 mt-5 text-light socialIcons" />
        </a>
        <a href="https://www.youtube.com/channel/UCS6pbbgzgeJxje8CoOGQ6dQ" target="_blank" rel="noreferrer">
          <FaYoutube className="fs-5 mt-5 text-light socialIcons" />
        </a>
      </div>
    </div>
  );
};
